import { Injectable } from "@angular/core";
import { HttpClient, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class OrdersService {
  private baseUrl: string = "/order";

  constructor(private _httpClient: HttpClient) {}

  async getOrders() {
    return this._httpClient.get(`${this.baseUrl}`).toPromise();
  }

  async addOrder(data: any = {}) {
    return this._httpClient.post(`${this.baseUrl}`, data).toPromise();
  }

  async editOrder(id: number, data: any = {}) {
    return this._httpClient.put(`${this.baseUrl}/${id}`, data).toPromise();
  }

  async deleteOrder(id: number) {
    return this._httpClient.delete(`${this.baseUrl}/${id}`).toPromise();
  }

  async listForClient(id: number){
    return this._httpClient.get(`/order/list/${id}`).toPromise();
  }

  async uploadDocument(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("PUT", `/order/upload/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }

  async uploadAttachment(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("PUT", `/order/upload/attachment/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }

  async deleteAttachment(id: number) {
    return this._httpClient.delete("/order/attachment/" + id).toPromise();
  }

  async uploadOrderChildAttachment(file: any, id: number) {
    const formData: FormData = new FormData();
    formData.append("file", file);
    const req: any = new HttpRequest("PUT", `/order/child/upload/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }

  async deleteChildAttachment(id: number) {
    return this._httpClient.delete("/order/child/file/" + id).toPromise();
  }

  async deleteDocument(id: number) {
    return this._httpClient.delete("/order/file/" + id).toPromise();
  }

  manageStatusOrder(id: number, data: any = {}) {
    return this._httpClient.put("/order/status/" + id, data).toPromise();
  }
}
